import * as React from "react";
import { forwardRef, memo } from "react";
const SvgRedo = (props, ref) => (React.createElement("svg", { width: 24, height: 24, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M396-200q-97 0-166.5-63T160-420t69.5-157T396-640h252l-76-76q-11-11-11-28t11-28 28-11 28 11l144 144q6 6 8.5 13t2.5 15-2.5 15-8.5 13L628-428q-11 11-28 11t-28-11-11-28 11-28l76-76H396q-63 0-109.5 40T240-420t46.5 100T396-280h244q17 0 28.5 11.5T680-240t-11.5 28.5T640-200z" })));
const ForwardRef = forwardRef(SvgRedo);
const Memo = memo(ForwardRef);
export default Memo;
